<template>
  <section class="app-main">



    <!--<transition name="fade" mode="out-in">-->



    <keep-alive :include="cachedViews">
      <router-view :key="key"></router-view>
    </keep-alive>

<!--      -->
<!--    &lt;!&ndash;列表页搜索缓存&ndash;&gt;-->
<!--    <router-view v-if="!($route.meta.keepAlive)"-->
<!--                 :key='key'></router-view>-->




    <!--key 为了解决动态路由参数的路由跳转时组件复用导致数据不变化，例如edit/1 -> add 时-->
    <!--		</transition>-->


    <back-to-top transitionName="fade"
                 :customStyle="myBackToTopStyle"
                 :visibilityHeight="400"
                 :backPosition="0"></back-to-top>

  </section>
</template>

<script>
import BackToTop from '@/components/BackToTop';

export default {
  name: 'AppMain',
  components: {
    BackToTop
  },

  computed: {
    // 解决：当使用路由参数时，例如从 /user/foo 导航到 /user/bar，原来的组件实例会被复用，意味着组件的生命周期钩子不会再被调用。
    key() {
      return this.$route.fullPath
        // return this.$route.path;
      // return this.$route.name !== undefined
      //   ? this.$route.name + +new Date()
      //   : this.$route + +new Date();
    },
    cachedViews() {
      return this.$store.getters.cachedViews;
    }
  },
  data() {
    return {
      myBackToTopStyle: {
        right: '15px',
        bottom: '15px',
        width: '30px',
        height: '30px',
        'z-index': 2000,
        color: '#ccd2e0',
        'border-radius': '4px',
        'line-height': '30px', // 请保持与高度一致以垂直居中
        background: '#79839c' // 按钮的背景颜色
      }
    };
  }
};
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 40px);
  position: relative;
  overflow: auto;
  background-color: #ebeff4;
}

.fixed-header + .app-main {
  padding-top: 84px;
}
</style>
<style lang="scss">
/* fix css style bug in open el-dialog*/

.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue